Vendd.Scripts.load(function () {
 
    if ($('.x-off-canvas-menu').length <= 0)
        return;

    if (isTouch()) {
        $(window).resize(function () {
            attachToCanvasMenu();
        });
    }

    var isMoved = false;

    if ($(window).width() < 1200) {
        if (isTouch()) {
            $('.header-usps-list').detach().prependTo('.js-canvas-menu').show();
            if ($('.x-currency-selector').length > 0)
                $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
                $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
            $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
            $('.header-region .x-language-selector').detach().prependTo('.js-canvas-menu').show();
            isMoved = true;
        }
    }

    function attachToCanvasMenu() {

        if ($(window).width() < 1200) {
            if (!isMoved) {
                $('.header-usps-list').detach().prependTo('.js-canvas-menu').show();

                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
                    $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
                $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
                $('.header-region .x-language-selector').detach().prependTo('.js-canvas-menu').show();

                isMoved = true;
            }
        } else {
            if (isMoved) {
                $('.off-canvas-menu .x-language-selector').detach().insertBefore('.x-sitelogo');

                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().insertBefore('.x-sitelogo');

                $('.js-main-menu').insertBefore('.x-sitelogo');
                $('.x-call-me-back-widget').detach().insertAfter('.x-login-widget');
                $('.header-usps-list').detach().appendTo('.header-template-one .inner-area-one');
                isMoved = false;
                $("html").removeClass("show-canvas");
                $('.site-overlay').hide();
            }
        }
    }

});
